import { authService } from '@services/auth.service';
import { useAppShellStore } from '@store/appShellStore';

/**
 * Re-reads the academic sessions into the app-shell store.
 *
 * The top-bar session switcher loads its list once during bootstrap, but a
 * session can come into existence at any time: filing an admission under a year
 * never used before creates one on demand, as does the financial year turning
 * over. Without this the new year is invisible until a page reload.
 *
 * Driven purely by the `sessions:changed` socket event, which the server emits
 * ONLY when a session record is actually created — so every connected user
 * (admin and staff alike) picks up the new year, and an admission filed under an
 * existing year costs no extra request.
 *
 * Failures are swallowed: this only refreshes a dropdown, and the list is
 * rebuilt on the next load regardless.
 */
export const refreshSessions = () =>
  authService
    .getSessions()
    .then(({ data }) => {
      useAppShellStore.getState().setSessions(data.items);
    })
    .catch(() => {});
